import { Badge, DataTable, Modal } from "@shopify/polaris";
import moment from "moment";
import React, { useCallback, useContext } from "react";
import { ContextUser } from "src/context/ContextUser";
import { useSupplierAdminQuery, useSupplierBankChangeLogQuery } from "src/graphql/codegen_graphql";

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export function ModalLogSellerBankAccount(props: Props) {
  const { merchant } = useContext(ContextUser);
  const { data, loading } = useSupplierBankChangeLogQuery({
    variables: {
      supplierId: Number(merchant.id),
    },
  });
  const AgentQuery = useSupplierAdminQuery({
    variables: {
      supplierId: 535,
    },
  });

  const toggleActive = useCallback(() => props.setOpen(!props.open), [props]);

  const agent = (
    <div style={{ marginTop: "1rem" }}>
      <div>
        <b>Your agent</b>
      </div>
      <div>
        <small>{AgentQuery.data?.supplier?.bankName || ""}</small>
      </div>
      <div>
        <small>{AgentQuery.data?.supplier?.bankAccountHolderName || ""}</small>
      </div>
      <div>
        <small>{AgentQuery.data?.supplier?.bankAccountNumber || ""}</small>
      </div>
    </div>
  );

  const list = data ? data.supplierBankChangeLog || [] : [];

  return (
    <Modal loading={loading} title="Log of Seller's Bank Account" open={props.open} onClose={toggleActive}>
      <Modal.Section flush>
        <DataTable
          columnContentTypes={["text", "text", "text"]}
          headings={["Date of Update", "Old Bank Information", "New Bank Information"]}
          rows={list.map((x, i) => {
            if (i === 0) {
              return [
                <div>
                  <div>
                    <small>{moment(x?.changedDate).format("YYYY-MM-DD")}</small>
                  </div>
                  <div>
                    <Badge tone="success">Current</Badge>
                  </div>
                </div>,
                <div>
                  <div>
                    <small>{x?.oldValue.bank}</small>
                  </div>
                  <div>
                    <small>{x?.oldValue.holder_name}</small>
                  </div>
                  <div>
                    <small>{x?.oldValue.account_number}</small>
                  </div>
                </div>,
                <div>
                  <div>
                    <small>{x?.newValue.bank}</small>
                  </div>
                  <div>
                    <small>{x?.newValue.holder_name}</small>
                  </div>
                  <div>
                    <small>{x?.newValue.account_number}</small>
                  </div>
                  {String(x?.newValue.bank || "").toLowerCase() === "alipay" && agent}
                </div>,
              ];
            }
            return [
              <div>
                <div>
                  <small>{moment(x?.changedDate).format("YYYY-MM-DD")}</small>
                </div>
              </div>,
              <div>
                <div>
                  <small>{x?.oldValue.bank}</small>
                </div>
                <div>
                  <small>{x?.oldValue.holder_name}</small>
                </div>
                <div>
                  <small>{x?.oldValue.account_number}</small>
                </div>
              </div>,
              <div>
                <div>
                  <small>{x?.newValue.bank}</small>
                </div>
                <div>
                  <small>{x?.newValue.holder_name}</small>
                </div>
                <div>
                  <small>{x?.newValue.account_number}</small>
                </div>
              </div>,
            ];
          })}
        />
      </Modal.Section>
    </Modal>
  );
}
